/*eslint-disable*/
export default form => {
  $(document).ready(() => {
    let $form = $(form)
    let $successMessage = $('.waitlist-success')
    let url = 'https://script.google.com/macros/s/AKfycbxRO6ukmbyokK8aulZ6pJgiLWNv2TL0sMpIbGCxAciNfF3WO14/exec'
    $form.on('submit', e => {
      e.preventDefault()
      $('#waitlist-remind-email-auth-button').css({ 'opacity': '0', 'visibility': 'hidden' })
      $('.waitlist-loader').css({ 'opacity': '1', 'visibility': 'visible' })
      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        data: serializeJqueryObject($form),
        success: data => {
          $successMessage.addClass('success')
          $form.addClass('hide')
          $('#waitlist-remind-email-auth-button').css({ 'opacity': '1', 'visibility': 'visible' })
          $('.waitlist-loader').css({ 'opacity': '0', 'visibility': 'hidden' })
        },
        error: error => {
          console.error(error)
        }
      })
    })
  })

  const serializeJqueryObject = $form => {
    let obj = {}
    let array = $form.serializeArray()
    array.forEach((entry, idx) => {
      if (obj[entry.name]) {
        if (!obj[entry.name].push) obj[entry.name] = [obj[entry.name]]
        obj[entry.name].push(entry.value || '')
      } else obj[entry.name] = entry.value || ''
    })
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/waitlist-form.js